export const EQUIPMENT_EVENTS = {
    CREATED: 'equipment.created',
    DELETED: 'equipment.deleted',
};
